(function ($) {
    RVwys.plugin['FooterEmail'] = true;

    $(document).bind('editorReady', function () {
        $('.btn-save-footerEmail').click(function () {
            parent.RVwys.saveEmailFooter();
        });
    });

    $(document).bind('designReady', function (e) {
        parent.$('.btn-reset-footerEmail').click(function () {
            var UI = parent.UIkit;

            var onCancel = function () {
                modal.hide();
            };

            var onInsert = function () {
                $.ajax({
                    type: 'POST',
                    url: '/admin/email/update/reset/footer',
                    data: {
                        email_id: parent.$('#email_id').val(),
                        email_type: parent.$('#isType').val(),
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                            'content'
                        ),
                    },
                    success: function (data) {
                        parent.$('#footer_custom').val('');
                        parent.$('#footer_id').val('0');

                        $('#rvcmsfooter div').first().replaceWith(data);
                        RVwys.CustomFooter();
                        parent.$('.wys-footerDesignEmail').hide();
                        parent.console.pop.success({
                            text: 'Reset Success',
                            delay: 5000,
                        });
                    },
                });

                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    `<div class="wys-rvemail">
                    <div class="uk-margin uk-modal-header"><h2>
                        ${rvLang('Reset Footer')}
                        </h2><span class="uk-modal-close uk-icon-close"></span></div>
                    <div class="uk-margin uk-modal-content"><span>
                        ${rvLang('Reset Footer to default?')}
                        </span></div>
                    <div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">
                        ${rvLang('Yes')}
                        </button>
                    <button class="uk-button js-modal-confirm-cancel">
                        ${rvLang('No')}
                    </button></div>
                    </div>`,
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    onCancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        });
    });

    RVwys.uikit.blockprop.FooterEmail = function () {
        RVwys.uikit.loadFooterDesignEmail();

        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-footerDesignEmail, .panelFooterEmail').show();
    };

    RVwys.uikit.loadSectionDesignEmail = function () {
        console.log($('#design-sortable-email'));
        //event
        $('#design-sortable-email').html(
            '<div class="txtSidebar">Loading...</div>'
        );

        var attrLayout = $('.design-block').attr('rv-layout');
        if (attrLayout == 'undefined' || attrLayout == undefined) {
            setTimeout(function () {
                RVwys.uikit.loadSectionDesignEmail();
            }, 500);
        }
        var requestAjax = $.ajax({
            method: 'GET',
            url: parent.wex.cdn.cdnBlockDesignEmail,
            dataType: 'html',
        });

        /*replace  rvs_library*/
        requestAjax.done(function (data) {
            $('#design-sortable-email').html('');
            const objBlock = $('<div/>').html(data);
            objBlock.find('icon').each(function () {
                $('#design-sortable-email').append(
                    $(this)
                        .find('.hvr-glow')
                        .attr('data', $(this).next('design').html())
                );
            });
        });
        requestAjax.fail(function (jqXHR, textStatus) {
            //RVwys.uikit.loadSectionDesignEmail();
            console.log('Cannot load ' + parent.wex.cdn.cdnBlockDesignEmail);
            console.log('Error msg ' + jqXHR.responseJSON.message);
        });
    };

    RVwys.uikit.loadFooterDesignEmail = function () {
        const attrLayout = $('.design-block').attr('rv-layout');
        if (attrLayout == 'undefined' || attrLayout == undefined) {
            setTimeout(function () {
                RVwys.uikit.loadFooterDesignEmail();
            }, 500);
        }

        if (parent.$('#FooterAlbumUikitEmail icon').length == '0') {
            parent
                .$('#FooterAlbumUikitEmail')
                .html('<div class="txtSidebar">Loading...</div>');
            var urlCDN = parent.wex.cdn.cdnFooterDesignEmail;
            var requestAjax = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            requestAjax.done(function (data) {
                //	    		alert(data);
                parent.$('#FooterAlbumUikitEmail').html('');
                var oRolsFooter = $('<div/>').html(data);
                oRolsFooter.find('icon').each(function () {
                    var FooterID = oRolsFooter.find('icon').attr('footer');
                    var IconFooter = $(this);
                    parent.$('#FooterAlbumUikitEmail').append($(this));
                    var urlCDNbyiTem =
                        parent.wex.cdn.cdnURL +
                        '/service/getdesign.php?name=footerdesign&email=email&item=' +
                        FooterID;
                    var requestbyiTem = $.ajax({
                        method: 'POST',
                        url: urlCDNbyiTem,
                        dataType: 'html',
                    });

                    requestbyiTem.done(function (data) {
                        var oRolsFooterHtml = $('<div/>').html(data);
                        var GroupSection = $('<div/>').html(
                            oRolsFooterHtml.find('div[data-emailfooter]')
                        );
                        var widgetDefault = `
                        <div class="socailFooter uk-text-left-small">
                            <div class="blockWidget" widget="rvsitebuilder/core" widgetname="social" icon="icon_new_blank" action="/admin/core/widget/getsocialwidgetfooter" panel=".wys-rowFooterSocial">
                                <div class="padd">
                                    <img class="imgsocial" srcs="${parent.wex.cdn.cdnURL}/templates/rvs_library/100/images/thumbnails/widget-social.png" width="200" height="22" border="0" widgetname="social" element=".socailFooter" widget="#socialbutton" data-appname="rvsitebuilder/core" />
                                </div>
                            </div>
                        </div>`;

                        GroupSection.find('.socailFooter').replaceWith(
                            widgetDefault
                        );
                        IconFooter.find('.hvr-glow').attr(
                            'data',
                            GroupSection.html()
                        );
                        IconFooter.find('.hvr-glow').click(function (e) {
                            var oRodata = $(this).attr('data');
                            var oThis = $(oRodata);
                            parent.EmailCssFooterID = oThis.data('emailfooter');
                        });

                        var oThisIcon = IconFooter.find('.hvr-glow');
                        RVwys.Footer.Preview(oThisIcon);
                    });
                });
            });
            requestAjax.fail(function (jqXHR, textStatus) {
                RVwys.uikit.loadFooterDesignEmail();
            });
        }
    };

    RVwys.designViewAddEvent('mousedown', function (e) {
        parent.$('.wys-InfoFooter').hide();
    });
})(jQuery);
